
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import UserUnSuspendingForm from './UserUnSuspendForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class UserUnSuspending extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} unSuspendUser={true}/>,
                id: 0,
            }, {
                title: 'Unsuspend User',
                content: <UserUnSuspendingForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default UserUnSuspending
